<div class="p-5 my-10 bg-white internet-plans-container rounded-2xl">
  <!-- Header -->
  <div class="flex items-center space-x-5">
    <button class="text-2xl text-gray-700" (click)="goToNextStep(1)">
      <i class="ri-arrow-left-long-line"></i>
    </button>
    <h1 class="text-2xl font-bold leading-8 text-gray-900 font-raleway">
      We have found 7 internet plans that may be available for your home.
    </h1>
  </div>

  <p class="py-4 text-base font-normal leading-6 text-gray-500 font-raleway">
    <strong class="text-lg font-medium text-gray-900">
      This is the address you gave us:
    </strong>
    <br />
    20277 Cockerill Road, Purcellville, VA, 20132
    <a href="#" class="text-base font-medium text-gray-800 underline">
      Verify another address
    </a>
  </p>

  <div
    class="flex items-center p-4 my-8 space-x-3 bg-yellow-100 border border-red-200 rounded-lg">
    <i class="text-lg text-red-500 ri-information-line"></i>
    <p class="text-base font-normal text-gray-700">
      After submitting your order, our team will contact you to confirm if your
      address is eligible.
    </p>
  </div>

  <!-- Plan Selection -->
  <h2 class="text-lg font-semibold leading-8 text-gray-900 font-raleway">
    Choose your internet plan
  </h2>
  <p class="text-base font-normal leading-6 text-gray-500 font-raleway">
    Plan prices include applicable taxes and fees.
  </p>

  <br/>
  <hr/>
  <h2 class="text-xl font-bold leading-8 text-gray-900 font-raleway">
    Residential Plans
  </h2>

  <div class="grid grid-cols-1 gap-5 mt-5 xl:grid-cols-2">
    <div
      *ngFor="let plan of residential_servicePlans"
      class="p-5 bg-white border border-gray-200 shadow-md rounded-2xl">
      <h3 class="text-lg font-semibold text-gray-900 font-raleway">
        {{ plan.name }}
      </h3>
      <div
        class="grid grid-cols-2 gap-8 p-4 my-5 border border-gray-200 rounded-xl bg-gray-50">
        <div>
          <p class="text-sm text-gray-500">Download speed</p>
          <div class="flex items-center pt-2">
            <img
              src="/dashboard/download.svg"
              alt="download"
              class="w-6 h-6 mr-1" />
            <strong class="pr-1 text-xl font-semibold text-gray-900">
              {{ plan.download_speed }}
            </strong>
            <p class="text-gray-600">Mbps</p>
          </div>
        </div>
        <div>
          <p class="text-sm text-gray-500">Upload speed</p>
          <div class="flex items-center pt-2">
            <img
              src="/dashboard/uploadIcon.svg"
              alt="upload"
              class="w-6 h-6 mr-1" />
            <strong class="pr-1 text-xl font-semibold text-gray-900">
              {{ plan.upload_speed }}
            </strong>
            <p class="text-gray-600">Mbps</p>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-3 my-3">
        <img src="/icons/info.svg" alt="info" class="w-5 h-5" />
        <p class="text-sm text-gray-700">
          Installation fee : {{plan.installation_fee | currency:'USD'}}
        </p>
        <p class="text-sm text-gray-700">
          No contract!
        </p>
          <p *ngFor="let feature of plan.features?.data" class="text-sm text-gray-700">
          {{ feature }}
        </p>        
      </div>

      <div
        class="flex items-center justify-between p-4 my-5 rounded-lg bg-blue-50">
        <p class="text-lg text-gray-700">
          <strong class="text-xl font-semibold text-gray-900">
            {{ plan.amount | currency : "USD" }}
          </strong>
          /month
        </p>
        <div class="flex items-center space-x-2">
          <label [for]="plan.slug" class="font-medium text-gray-700">
            Select
          </label>
          <input
            type="radio"
            [id]="plan.slug"
            name="selectedPlan"
            class="w-5 h-5 accent-blue-500" />
        </div>
      </div>
    </div>
  </div>
  <h2 class="mt-4 text-xl font-bold leading-8 text-gray-900 font-raleway">
    Business Plans
  </h2>
    <div class="grid grid-cols-1 gap-5 mt-5 xl:grid-cols-2">
    <div
      *ngFor="let plan of commercial_servicePlans"
      class="p-5 bg-white border border-gray-200 shadow-md rounded-2xl">
      <h3 class="text-lg font-semibold text-gray-900 font-raleway">
        {{ plan.name }}
      </h3>
      <div
        class="grid grid-cols-2 gap-8 p-4 my-5 border border-gray-200 rounded-xl bg-gray-50">
        <div>
          <p class="text-sm text-gray-500">Download speed</p>
          <div class="flex items-center pt-2">
            <img
              src="/dashboard/download.svg"
              alt="download"
              class="w-6 h-6 mr-1" />
            <strong class="pr-1 text-xl font-semibold text-gray-900">
              {{ plan.download_speed }}
            </strong>
            <p class="text-gray-600">Mbps</p>
          </div>
        </div>
        <div>
          <p class="text-sm text-gray-500">Upload speed</p>
          <div class="flex items-center pt-2">
            <img
              src="/dashboard/uploadIcon.svg"
              alt="upload"
              class="w-6 h-6 mr-1" />
            <strong class="pr-1 text-xl font-semibold text-gray-900">
              {{ plan.upload_speed }}
            </strong>
            <p class="text-gray-600">Mbps</p>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-3 my-3">
        <img src="/icons/info.svg" alt="info" class="w-5 h-5" />
        <p class="text-sm text-gray-700">
          Installation fee : {{plan.installation_fee | currency:'USD'}}
        </p>
        <p class="text-sm text-gray-700">
          No contract!
        </p>
        <p *ngFor="let feature of plan.features?.data" class="text-sm text-gray-700">
          {{ feature }}
        </p>        
      </div>

      <div
        class="flex items-center justify-between p-4 my-5 rounded-lg bg-blue-50">
        <p class="text-lg text-gray-700">
          <strong class="text-xl font-semibold text-gray-900">
            {{ plan.amount | currency : "USD" }}
          </strong>
          /month
        </p>
        <div class="flex items-center space-x-2">
          <label [for]="plan.slug" class="font-medium text-gray-700">
            Select
          </label>
          <input
            type="radio"
            [id]="plan.slug"
            name="selectedPlan"
            class="w-5 h-5 accent-blue-500" />
        </div>
      </div>
    </div>
  </div>
</div>
